import styled from "@emotion/styled";
import { ThemeKey } from "@smartsheet/design-tokens";
import { datePickerTheme } from "./datePickerTheme";

export interface DatePickerDialogStyledProps {
    themeMode: ThemeKey;
}

export const DatePickerDialogStyled = styled("div")<DatePickerDialogStyledProps>`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    box-sizing: border-box;
    ${({ themeMode }) => `
        background: ${datePickerTheme.backgroundColor(themeMode)};
        box-shadow: ${datePickerTheme.boxShadow(themeMode)};
        border-radius: ${datePickerTheme.borderRadius(themeMode)};
        padding: ${datePickerTheme.padding(themeMode)};
    `}
`;
